import { api } from './BaseService'

export const getDeliveryPartners = async () => {
    return await api.get(`/delivery_partners`)
}

export const getDeliveryPartnerById = async (id) => {
    return await api.get(`/delivery_partners/${id}`)
}

export const createDeliveryPartner = async (data) => {
    return await api.post(`/delivery_partners`, data)
}
export const updateDeliveryPartner = async (data) => {
    return await api.put(`/delivery_partners/${data?.id}`, data)
}
export const deleteDeliveryPartner = async (id) => {
    return await api.delete(`/delivery_partners/${id}`)
}
